import { localStorageKeys } from '@/utils/local-storage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type UiStorePersistent = {
  isDarkMode: boolean;
  setIsDarkMode: (isDark: boolean) => void;
};

type UiStore = {
  isMenuSidebarOpen: boolean;
  setIsMenuSidebarOpen: (isOpen: boolean) => void;
};

export const useUiStorePersistent = create<UiStorePersistent>()(
  persist(
    (set) => ({
      isDarkMode: true,
      setIsDarkMode: (isDark: boolean) => set({ isDarkMode: isDark }),
    }),
    {
      name: localStorageKeys.uiSettings,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export const useUiStore = create<UiStore>()((set) => ({
  isMenuSidebarOpen: false,
  setIsMenuSidebarOpen: (isOpen: boolean) =>
    set({ isMenuSidebarOpen: isOpen }),
}));
